module.exports = __webpack_public_path__ + "resources/img/main_banner_cloud01.e9e4ffd8109e46dfdd92d08c2cca68a7.png";